import { createSelector } from "@reduxjs/toolkit";
import { DateTime } from "luxon";
import * as con from "../../GlobalConstants.js";


export const selectIsAppReady = (state) => {

  return (
    state[con.REDUCER_AUTHENTICATION][con.IS_AUTHENTICATED] &&
    state[con.REDUCER_APPLICATION_PARAMETERS][con.SERVER][con.STATUS] === con.OK
  );
};

export const selectCurrentDateISO = (state) =>
  state[con.REDUCER_APPLICATION_PARAMETERS][con.CURRENT_DATE];


export const selectCurrentDate = createSelector(
  [selectCurrentDateISO],
  (iso) => iso ? DateTime.fromISO(iso) : null
);

export const selectIsUserInformationSaved = (state) => {

  return (
    state.model_parameters[con.MODEL_PARAMETERS_SAVED]
  );
};